export default __webpack_public_path__ + "static/media/create-property-illustration.fe6d1c4c.png";